import { Component } from '@angular/core';

@Component({
  selector: 'app-product-service-search',
  templateUrl: './product-service-search.component.html',
  styleUrls: ['./product-service-search.component.css']
})
export class ProductServiceSearchComponent {

  product_chunk=[
    [
      {
        icon_image: "https://image.bajajcapitalone.com/bajajcapital/Avail-Insurance.png",
        link_name: "Avail Insurance",
        link_url: "https://www.bajajcapitalinsurance.com/",
        target_id: "976",
        target_revision_id: "10163"
      },
      {
        icon_image: "https://image.bajajcapitalone.com/bajajcapital/Invest-MF.png",
        link_name: "Invest in Mutual Funds ",
        link_url: "https://onlinemf.bajajcapital.com/login.aspx",
        target_id: "905",
        target_revision_id: "10164"
      },
      {
        icon_image: "https://image.bajajcapitalone.com/bajajcapital/Invest-NPS.png",
        link_name: "Invest in NPS",
        link_url: "https://www.bajajcapitalone.com/nps/",
        target_id: "977",
        target_revision_id: "10165"
      },
      {
        icon_image: "https://image.bajajcapitalone.com/bajajcapital/Company-FD.png",
        link_name: "Invest in Company Fixed Deposits ",
        link_url: "https://www.bajajcapitalone.com/fixed-deposit/campaign/001/apply-now.html",
        target_id: "978",
        target_revision_id: "10166"
      },
    ],
    [
      {
        icon_image: "https://image.bajajcapitalone.com/bajajcapital/Avail-personal-loan.png",
        link_name: "Avail a Personal Loan",
        link_url: "https://www.bajajcapitalone.com/loans/personal-loan/",
        target_id: "979",
        target_revision_id: "10167"
      },
      {
        icon_image: "https://image.bajajcapitalone.com/bajajcapital/credit-cards.png",
        link_name: "Get Credit Cards ",
        link_url: "https://www.bajajcapitalone.com/credit-card/",
        target_id: "980",
        target_revision_id: "10168"
      },
      {
        icon_image: "https://image.bajajcapitalone.com/bajajcapital/home-loan.png",
        link_name: "Avail a Home Loan",
        link_url: "https://www.bajajcapitalone.com/loans/home-loan/campaign/002/apply-now.html",
        target_id: "981",
        target_revision_id: "10169"
      },
      
    ]
  ]
  service_chunk=[]

}
